// extracted by mini-css-extract-plugin
export default {"selectWrapper":"select_selectWrapper__4T88t","menuItem":"select_menuItem__KnmS8"};